<template>
  <div class="v-tokenInput">
    <input
      class="v-tokenInput__field"
      :class="{
        'v-tokenInput--completed': tokenCompleted,
        'v-tokenInput--focused': tokenFocused,
        'v-tokenInput--blured': tokenBlured,
        'v-tokenInput--incompleted': tokenIncompleted,
      }"
      :ref="inputId"
      type="number"
      :id="inputId"
      :maxLength="inputMaxLength"
      :tabindex="inputTabindex"
      v-model="inputValue"
      @keydown="handleKeypress"
      @input="$emit('input', $event.target.value)"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
      @click="$emit('click', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'VNewTokenInput',

  props: {
    inputId: {
      type: String,
      default: 'token_input',
    },
    inputMaxLength: {
      type: Number,
      default: 1,
    },
    inputTabindex: {
      type: Number,
      default: 1,
    },
    tokenCompleted: {
      type: Boolean,
      default: false,
    },
    tokenFocused: {
      type: Boolean,
      default: false,
    },
    tokenBlured: {
      type: Boolean,
      default: true,
    },
    tokenIncompleted: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      inputValue: '',
    };
  },

  methods: {
    handleKeypress(event) {
      if (event.key === 'Backspace') {
        if (!this.inputValue) {
          this.$emit('focusPreviousField', event);
        }
      }

      return this.$emit('keypress', event);
    },
  },
};
</script>

<style lang="scss" scoped>
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.v-tokenInput {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 40.65px;
  height: 43.35px;
  background: #ffffff;
  border: none;

  &--incompleted {
    border: 1px solid #ea4356;
    border-radius: 4px;
  }

  &--completed {
    border: 1px solid #2d954c;
    border-radius: 4px;
  }

  &--focused {
    border: 1px solid #00229e;
    border-radius: 4px;
  }

  &--blured {
    border: 1px solid #666666;
    border-radius: 4px;
  }

  &__field {
    // background-color: var(--color-grey-1);
    border-radius: 4px;
    // border: 0px;

    font-size: 16px;
    height: 100%;
    text-align: center;
    transition: 0.5s all;
    width: 100%;

    &:focus {
      // border: 1px solid #00229e;
    }

    &:disabled {
      background-color: var(--color-grey-2);
      color: var(--color-grey-4);
    }
  }
}
</style>
